import React, { Suspense, useState } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import AdminNavRail, { readCollapsed } from './nav/AdminNavRail';
import AdminNavSheet from './nav/AdminNavSheet';
import { findNavItem, DEFAULT_PATH } from './nav/adminNav';

function PanelSkeleton() {
  return (
    <div className="p-6 space-y-4 animate-pulse" role="status" aria-label="Loading panel">
      <div className="h-6 w-48 bg-gray-200 dark:bg-gray-700 rounded" />
      <div className="h-32 bg-gray-200 dark:bg-gray-700 rounded" />
      <div className="h-32 bg-gray-200 dark:bg-gray-700 rounded" />
    </div>
  );
}

// Renders the panel for the current /:groupId/:itemId, or bounces to Overview
// when the slug is unknown (stale bookmark, hand-typed URL, renamed panel).
function PanelRoute() {
  const { groupId, itemId } = useParams();
  const match = findNavItem(groupId, itemId);
  if (!match) return <Navigate to={DEFAULT_PATH} replace />;
  const { group, item } = match;
  const Panel = item.Component;

  return (
    <>
      <div className="mb-4">
        <p className="text-xs font-rasa uppercase tracking-wide text-gray-400 dark:text-gray-500">{group.label}</p>
        <h2 className="text-xl font-unna font-bold text-gray-800 dark:text-gray-100">{item.label}</h2>
      </div>
      <Suspense fallback={<PanelSkeleton />}>
        <Panel />
      </Suspense>
    </>
  );
}

export default function AdminShell() {
  const [collapsed, setCollapsed] = useState(readCollapsed);

  return (
    <div className="h-full flex flex-col max-w-screen-2xl mx-auto w-full">
      <div className="flex items-center justify-between px-4 pt-4 pb-2 flex-shrink-0">
        <h1 className="text-2xl font-bold font-rasa dark:text-gray-100">Admin</h1>
      </div>

      <div className="flex-1 flex min-h-0">
        <AdminNavRail collapsed={collapsed} setCollapsed={setCollapsed} />

        <main className="flex-1 min-w-0 overflow-y-auto p-4">
          <Routes>
            <Route index element={<Navigate to={DEFAULT_PATH} replace />} />
            <Route
              path=":groupId/:itemId"
              element={
                <>
                  <AdminNavSheet />
                  <PanelRoute />
                </>
              }
            />
            <Route path="*" element={<Navigate to={DEFAULT_PATH} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
